/**
 * Creates a counter
 * @module incrementCount
 */

 import $ from 'jquery';
 import registerJQueryPlugin from '../lib/register-jquery-plugin';
 import mergeOptions from '../lib/merge-options';
 export const PLUGIN_NAME = 'incrementCount';
 export const CLICK_EVENT = 'click';
 export const CHANGE_EVENT = 'change';

 export const DEFAULTS = {
   count: 0,
 };

 // Expose the function as a jQuery plugin for ease of use
 registerJQueryPlugin(PLUGIN_NAME, incrementCount);

 /**
  * Initializes blank based on provided parameters.
  * @param {HTMLElement} el - An element containing the elements for the
  * Counter
  * @param {Object} options - Options used for wiring up the Count
  * @see DEFAULTS
  */
 export default function incrementCount(el, options = {}) {
   const $el = $(el);
   const opts = mergeOptions(DEFAULTS, options, $el);

   applyEventHandlers($el, opts);
 };


 /**
  * Applies any sort of event handlers for the count incrementation.
  * @param {jQuery} $el - Containing the elements for the Counter
  * @param {Object} options - Options used for wiring up the Counter
  * @see DEFAULTS
  */
  const applyEventHandlers = ($el, opts = {}) => {
    $el.find('.js-plus').on(CLICK_EVENT, function(evt) {
      plus(evt, $el, opts);
    });

    $el.find('.js-minus').on(CLICK_EVENT, function(evt) {
      minus(evt, $el, opts);
    });

    $el.find('.js-checkin').on(CHANGE_EVENT, function(evt) {
      checkin(evt, $el, opts);
    });

  }

  const plus = (evt, $el, opts) => {
    evt.preventDefault();
    const $elCount = $el.find('.js-count');
    const $elCheckin = $el.find('.js-checkin');
    if($elCheckin.is(':checked')){ return; }

    opts.count++;
    $elCount.val(opts.count);
  }

  const minus = (evt, $el, opts) => {
    evt.preventDefault();
    const $elCount = $el.find('.js-count');
    const $elCheckin = $el.find('.js-checkin');
    if($elCheckin.is(':checked')){ return; }

    if (opts.count > 0) {
      opts.count--;
      $elCount.val(opts.count);
    }
  }

  const checkin = (evt, $el, opts) => {
    const $elCount = $el.find('.js-count');
    const $elTotal = $el.find('.js-total');
    const $elCheckin = $el.find('.js-checkin');
    if($elCheckin.is(':checked')){
      let $elSum = (parseInt($elCount.val(), 10) + parseInt(1, 10));
      $elTotal.val($elSum);
    } else {
      $elTotal.val(0);
    }
  }



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/increment-count.js